import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "wordcloud",
  methods: {
    updateChart: function updateChart() {
      var _this = this;

      var optionData = this.deepClone(this.dataChart) || [];
      var option = {
        series: [{
          type: "wordCloud",
          left: "center",
          top: "center",
          width: "100%",
          height: "100%",
          right: null,
          bottom: null,
          sizeRange: function () {
            return [_this.option.minFontSize || 12, _this.option.maxFontSize || 60];
          }(),
          rotationRange: function () {
            if (_this.option.rotate) {
              return [-90, 90];
            } else {
              return [0, 0];
            }
          }(),
          rotationStep: function () {
            if (_this.option.rotate) {
              return 45;
            } else {
              return 0;
            }
          }(),
          gridSize: this.option.split || 30,
          drawOutOfBound: false,
          textStyle: {
            normal: {
              fontFamily: "sans-serif",
              fontWeight: "bold",
              color: function color() {
                return "rgb(" + [Math.round(Math.random() * 160), Math.round(Math.random() * 160), Math.round(Math.random() * 160)].join(",") + ")";
              }
            },
            emphasis: {
              shadowBlur: 10,
              shadowColor: "#333"
            }
          },
          data: optionData
        }]
      };
      this.myChart.resize();
      this.myChart.setOption(option, true);
    }
  }
});